// import React from 'react'
// import s1 from "../assets/s1.png";
// import a1 from "../assets/a1.png";
// import a2 from "../assets/a2.png";
// import a3 from "../assets/a3.png";
// import a4 from "../assets/a4.png";
// import PhoneHeader from "./PhoneHeader";

// const APIIntergationService = () => {
//   const data = [
//     {
//       title: "Financial Inclusion",
//       text: "Brings banking to remote or rural areas without branches."
//     },
//     {
//       title: "Secure & Reliable",
//       text: "Uses Aadhaar authentication, reducing fraud risk."
//     },
//     {
//       title: "No Card Required",
//       text: "Works without debit/credit cards or smartphones in some cases."
//     },

//   ];
//   return (
//     <>
//     <PhoneHeader title="API Integration Services" className="d-md-none d-block" />
//       <div className="container-fluid d-md-block d-none">
//         <div
//           className="text-center top-heading section"
//         >
//           <h1>API Integration Services</h1>
//         </div>
//       </div>
//       <div className="container">
//         <div className="row section">
//           <div className="col-md-6">
//             <h1><strong>Overview</strong></h1>
//           </div>
//           <div className="col-md-6">
//             <p>
//               <strong style={{ color: "#FF7A60",fontSize:"26px" }}>W</strong>e provide full-spectrum IT services tailored for financial service agents, micro-ATM operators, and fintech partners. Based on the model of PaymentHub’s IT offering.
//             </p>
//           </div>
//         </div>

//         <div className="section">
//           <img src={s1} className="w-100" />
//         </div>

//         <div className="row section g-4" style={{textAlign:"center"}}>
//              <h2 className='mt-4 mb-5' style={{textAlign:"center",fontWeight:"600"}}>APIs Available</h2>
//           <div className='col-md-3' >
//             <div className='py-4 px-2 h-100' style={{backgroundColor:"#FFDED3",borderRadius:"20px"}}>
//                 <img src={a1} className='mt-4 mb-4' style={{display:"block",marginLeft:"auto",marginRight:"auto"}}/>
//             <h5 style={{fontWeight:"600"}}>GST / MSME (Udyam) Registration.</h5>
//             <p>GST registration & return filing <br /> paymenthub</p>
//             </div>
//           </div>
//           <div className='col-md-3'>
//             <div className='py-4 px-2 h-100 ' style={{backgroundColor:"#E0FBFF",borderRadius:"20px"}}>
//                  <img src={a2} className='mt-4 mb-4' style={{display:"block",marginLeft:"auto",marginRight:"auto"}}/>
//             <h5 style={{fontWeight:"600"}}>FSSAI License Registration.</h5>
//             <p>income tax return (ITR) filing <br /> paymenthub.</p>
//             </div>
//           </div>
//            <div className='col-md-3' >
//             <div className='py-4 px-2 h-100 'style={{backgroundColor:"#EBF4E7",borderRadius:"20px"}}>
//                 <img src={a3} className='mt-4 mb-4' style={{display:"block",marginLeft:"auto",marginRight:"auto"}}/>
//             <h5 style={{fontWeight:"600"}}>Trademark Filing</h5>
//             <p>Set up, manage, and maintain your <br /> infrastructure.</p>
//             </div>
//           </div>
//           <div className='col-md-3' >
//             <div className='py-4 px-2 h-100 ' style={{backgroundColor:"#FFEDD3",borderRadius:"20px"}}>
//                 <img src={a4} className='mt-4 mb-4' style={{display:"block",marginLeft:"auto",marginRight:"auto"}}/>
//             <h5 style={{fontWeight:"600"}}>Company Formation (Pvt. Ltd, Ltd, NGO, Trust)</h5>
//             <p>Set up, manage, and maintain your <br /> infrastructure.</p>
//             </div>
//           </div>
//         </div>

//          {/* benefits */}
//        <div className="section d-none d-md-block">
//           <h2 className="text-center fw-bold mb-5">Benefits</h2>

//           <div className="benefits-wrapper position-relative">
//             <div className="benefit"></div>
//             <div className="center-line"></div>

//             <div className="row align-items-center mb-5">
//               <div className="col-6 text-end">
//                 <div className="benefit-card">
//                   <h5 className="fw-bold text-start mb-3">Professional help to navigate legal processes.</h5>
//                   <p className="text-start">
// One-stop bill payment portal for multiple services.                  </p>
//                 </div>
//               </div>
//               <div className="col-6"></div>
//             </div>

//             <div className="row align-items-center mb-5">
//               <div className="col-6"></div>
//               <div className="col-6">
//                 <div className="benefit-card-1">
//                   <h5 className="fw-bold mb-3">Saves time and cost with expert support..</h5>
//                   <p>Backed by established payment network.</p>
//                 </div>
//               </div>
//             </div>

//             <div className="row align-items-center mb-5">
//               <div className="col-6 text-end">
//                 <div className="benefit-card">
//                   <h5 className="fw-bold text-start mb-3">Affordable service suited for small businesses, retailers, or agents.</h5>
//                   <p className="text-start">
//                     Agents can facilitate bill payments and earn fees. (Modelled like PaymentHub)
//                   </p>
//                 </div>
//               </div>
//               <div className="col-6"></div>
//             </div>
//           </div>
//         </div>
//         <div className="section d-md-none d-block">
//           <h2 className="text-center fw-bold mb-5">Benefits</h2>

//           <div className="row justify-content-center">
//             {data.map((item, index) => (
//               <div className="col-12 mb-3" key={index}>
//                 <div className="benefit-box text-center p-4">
//                   <h5 className="mb-2" style={{fontWeight:"700"}}>{item.title}</h5>
//                   <p className="mb-0">{item.text}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </>
//   )
// }

// export default APIIntergationService
import React from "react";
import s1 from "../assets/s1.png";
import solution from "../assets/solution.png";
import solution1 from "../assets/exchange.png";
import solution2 from "../assets/neural.png";
import solution3 from "../assets/cash-withdrawal.png";
import solution4 from "../assets/files.png";
import solution5 from "../assets/shield.png";
import PhoneHeader from "./PhoneHeader";
import benfits from "../assets/benfites.jpg";

const APIIntergationService = () => {
  return (
    <>
      <PhoneHeader title="AEPS Service" className="d-md-none d-block" />

      {/* <div className="container-fluid d-md-block d-none">
        <div className="text-center top-heading section">
          <h1>AEPS Service</h1>
        </div>
      </div> */}
      <div className="container space">
        <div className="text-center top-heading section">
          <h1 className="mb-0">API Services</h1>
        </div>
        <div className="row section align-items-center">
          <div className="col-12 col-md-7">
            <div className="">
              <h1>
                <strong>Overview</strong>
              </h1>
            </div>
            <p>
              {/* <strong style={{ color: "#FF7A60", fontSize: "26px" }}>O</strong> */}
              Our API Services are designed to empower fintech companies, AEPS
              providers, developers, and businesses with seamless integration of
              digital financial solutions. Whether you want to build your own
              portal, mobile app, or fintech platform, our secure and
              high-performance APIs help you deliver reliable banking and
              payment services with ease.
            </p>
          </div>
          <div className="col-12 col-md-5 mb-3 mb-md-0">
            <div className="">
              <img src={s1} className="w-100 m-auto img-holl" />
            </div>
          </div>
        </div>

        <div
          className="row section p-md-4 px-1 pt-5 pb-4"
          style={{ backgroundColor: "#FFF6F3" }}
        >
          <div className="col-12 col-md-6 m-auto text-center d-none d-md-block">
            <img src={solution} alt="solution" className="img-fluid" />
          </div>

          <div className="col-12 col-md-6 m-auto">
            <h2 className="mb-md-5 mb-3 center" style={{ fontWeight: "700" }}>
              Why Choose Our API Services?
            </h2>

            <div className="solution-icon gap-3">
              <div className="m-auto solution-icon-wrapper">
                <img src={solution5} alt="" className="img-fluid" />
              </div>
              <div className="solution-icon-2">
                <h6 className="mb-2" style={{ fontWeight: "700" }}>
                  Fast & Easy Integration
                </h6>
                <p className="mb-0">
                  Developer-friendly documentation, SDKs, and sandbox access for
                  quick deployment.
                </p>
              </div>
            </div>

            <div className="solution-icon gap-3">
              <div className="m-auto solution-icon-wrapper">
                <img src={solution1} alt="" className="img-fluid" />
              </div>
              <div className="solution-icon-2">
                <h6 className="mb-2" style={{ fontWeight: "700" }}>
                  High Security Standards
                </h6>
                <p className="mb-0">
                  End-to-end encryption, secure API gateways, and compliance
                  with banking norms ensure safe transactions.
                </p>
              </div>
            </div>

            <div className="solution-icon gap-3">
              <div className="m-auto solution-icon-wrapper">
                <img src={solution2} alt="" className="img-fluid" />
              </div>
              <div className="solution-icon-2">
                <h6 className="mb-2" style={{ fontWeight: "700" }}>
                  Scalable Infrastructure
                </h6>
                <p className="mb-0">
                  Support millions of requests with robust servers and optimized
                  load handling.
                </p>
              </div>
            </div>

            <div className="solution-icon gap-3">
              <div className="m-auto solution-icon-wrapper">
                <img src={solution3} alt="" className="img-fluid" />
              </div>
              <div className="solution-icon-2">
                <h6 className="mb-2" style={{ fontWeight: "700" }}>
                  24/7 Technical Support
                </h6>
                <p className="mb-0">
                  Our expert team provides round-the-clock assistance for
                  integration, testing, and live operation.
                </p>
              </div>
            </div>

            <div className="solution-icon gap-3">
              <div className="m-auto solution-icon-wrapper">
                <img src={solution4} alt="" className="img-fluid" />
              </div>
              <div className="solution-icon-2">
                <h6 className="mb-2" style={{ fontWeight: "700" }}>
                  Customizable Solutions
                </h6>
                <p className="mb-0">
                  We tailor APIs to fit your business model—whether you're
                  building an app, website, or multi-service portal.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="row justify-content-center g-4 section">
          <h2
            className="mt-4 mb-5"
            style={{ textAlign: "center", fontWeight: "600" }}
          >
            Our API Solutions
          </h2>
          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4 text-center rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#FFDED3" }}
            >
              {/* <img
                src={so1}
                alt="Software Development"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold">AEPS API</h5>
              <p className="mt-2 flex-grow-1">
                Our AEPS API offers Aadhaar-enabled banking services on your
                platform that includes cash withdrawal, balance enquiry, mini
                statement, aadhar pay, biometric verification which is
                compliant, secure, and optimized for high success rates.
              </p>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4 text-center rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#E0FBFF" }}
            >
              {/* <img
                src={so2}
                alt="Hardware Support"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold">UPI API</h5>
              <p className="mt-2 flex-grow-1">
                Integrate UPI payments—Send, Collect, QR payments, and merchant
                acceptance—into your application or portal. Secure, instant, and
                fully reliable.
              </p>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4 text-center rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#EBF4E7" }}
            >
              {/* <img
                src={so3}
                alt="Network & Maintenance"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold">UPI ATM API</h5>
              <p className="mt-2 flex-grow-1">
                Enable card-less cash withdrawals using QR-based authentication.
                A modern solution for fintechs offering Micro-ATM or next-gen
                ATM services.
              </p>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4 text-center rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#E0FBFF" }}
            >
              {/* <img
                src={so1}
                alt="Software Development"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold">BBPS API</h5>
              <p className="mt-2 flex-grow-1">
                Provide a full suite of bill payment categories, including
                electricity, water, gas, broadband, DTH, EMI, insurance, and
                more. Real-time confirmation with secure APIs.
              </p>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4 text-center rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#EBF4E7" }}
            >
              {/* <img
                src={so2}
                alt="Hardware Support"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold">Recharge API</h5>
              <p className="mt-2 flex-grow-1">
                Support prepaid mobile, DTH, and data-card recharge services
                with instant success and 24/7 availability.
              </p>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4 text-center rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#FFDED3" }}
            >
              {/* <img
                src={so3}
                alt="Network & Maintenance"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold">DMT (Money Transfer) API</h5>
              <p className="mt-2 flex-grow-1">
                Offer secure and instant bank-to-bank domestic money transfer
                services with high uptime and complete verification protocols.
              </p>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4 text-center rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#FFDED3" }}
            >
              {/* <img
                src={so3}
                alt="Network & Maintenance"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold">PAN & Verification APIs</h5>
              <p className="mt-2 flex-grow-1">
                Instant PAN verification, Aadhaar verification, voter ID
                verification, and KYC APIs to enhance security and compliance
                for digital platforms.
              </p>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4 text-center rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#EBF4E7" }}
            >
              {/* <img
                src={so3}
                alt="Network & Maintenance"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold">Micro ATM API</h5>
              <p className="mt-2 flex-grow-1">
                Enable merchants to offer cash withdrawal, balance inquiry, and
                card-based services through Micro-ATM machines.
              </p>
            </div>
          </div>
        </div>

        <div className="section key-features align-items-center py-md-5 p-4">
          {/* HEADING */}
          <h2 className="fw-bold text-center mb-4">
            Who Can Start With API Services{" "}
          </h2>

          <div className="row">
            {/* IMAGE */}
            <div className="col-12 col-md-5  text-center mb-4 mb-md-0">
              <img
                src={benfits}
                alt="Key Features"
                className="img-fluid img-holl"
                style={{ maxWidth: "100%", width: "100%" }}
              />
            </div>

            {/* FEATURE LIST */}
            <div className="col-12 col-md-7 m-auto">
              <ul className="list-unstyled mx-auto">
                <li className=" mb-3">
                  • AEPS companies & fintech service providers
                </li>
                <li className=" mb-3">
                  • Developers creating payment apps or portals{" "}
                </li>
                <li className=" mb-3">
                  • Entrepreneurs launching digital service platforms
                </li>
                <li className=" mb-3">
                  • Banking correspondents & BC network operators
                </li>
                <li className="mb-3">
                  • Businesses wanting to integrate digital payments
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default APIIntergationService;
